import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { BrokerCard } from './BrokerCard';
import { BrokerCardMobile } from './BrokerCardMobile';
export const SearchedDomainBroker = _ref => {
  let domainName = _ref.domainName;
  return useIsMobile() ? /*#__PURE__*/React.createElement(BrokerCardMobile, {
    domainName: domainName
  }) : /*#__PURE__*/React.createElement(BrokerCard, {
    domainName: domainName
  });
};
//# sourceMappingURL=SearchedDomainBroker.js.map